import React, { Component } from "react";
import selectn from "selectn";
import { Link } from "react-router-dom";
import formatPublishedDate from "../../../utils/formatPublishedDate";

import { FRONTEND_ROOT } from "../../../config/constants";
import styles from "./MiniStoryCard.css";

class MiniStoryCard extends Component {
  render() {
    const latest = this.props.latest;
    if (!latest) return null;
    const section =
      latest.content_type === "newsletter"
        ? "Newsletters"
        : selectn("primary_section.name", latest);
    const publishedDateFormatted = formatPublishedDate(latest);
    const divider =
      (latest.is_featured || publishedDateFormatted) && section && " / ";
    return (
      <div key={latest.id} className={styles.root}>
        <Link
          className={styles.headline}
          to={latest.permalink.replace(FRONTEND_ROOT, "")}
        >
          <h3 className={styles.headline}>{latest.headline}</h3>
        </Link>
        <div className={styles.subtext}>
          {latest.is_featured ? (
            <span className={styles.featured}>Featured</span>
          ) : (
            publishedDateFormatted
          )}
          {divider}
          {section}
        </div>
      </div>
    );
  }
}

export default MiniStoryCard;
